import _ from 'lodash'
import moment from 'moment'
import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import Editor from './editor'
import { tr } from '../../helpers/languages'
import { send } from '../../helpers/requests'
import Note from './note'
import { actions as messages } from '../../store/actions/messages'
import Warning from './warning'

class Availability extends Component {
    constructor (props) {
        super(props)
        this.days = [
            tr('MONDAY'),
            tr('TUESDAY'),
            tr('WEDNESDAY'),
            tr('THURSDAY'),
            tr('FRIDAY'),
            tr('SATURDAY'),
            tr('SUNDAY')
        ]
        this.state = {
            schedule: this.days.map((day, index) => {
                return {
                    index,
                    name: day,
                    available: false,
                    slots: [{
                        start: moment('10:00', 'HH:mm'),
                        end: moment('18:00', 'HH:mm')
                    }]
                }
            }),
            doNotDisturb: false,
            errors: {},
            conflicts: [],
            forced: false
        }
        autoBind(this)
    }

    componentDidMount () {
        if (this.props.userTokens.accessToken.token) {
            // Fetch the availability.
            this.fetchAvailability()
        }
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.userTokens.accessToken.token !== this.props.userTokens.accessToken.token) {
            // Fetch the availability.
            this.fetchAvailability()
        }
    }

    // Sets the given value to the given field in the given slot (index) of the given day (index).
    setValue (day, slot, field, value) {
        if (value == null) {
            return
        }
        const schedule = this.state.schedule.map((d, di) => {
            return di === day ? {
                ...d,
                slots: d.slots.map((s, si) => {
                    return si === slot ? { ...s, [field]: value } : s
                })
            } : d
        })
        this.setState({ schedule })
    }

    // Adds a new slot to the given day (index).
    addSlot (day) {
        this.setState({
            schedule: this.state.schedule.map((d, i) => {
                return i === day ? {
                    ...d,
                    slots: d.slots.concat({
                        start: moment('10:00', 'HH:mm'),
                        end: moment('18:00', 'HH:mm')
                    })
                } : d
            })
        })
    }

    // Removes  the given slot (index) from the given day (index).
    removeSlot (day, slot) {
        this.setState({
            schedule: this.state.schedule.map((d, di) => {
                return di === day ? {
                    ...d,
                    slots: d.slots.filter((_s, si) => {
                        return si !== slot
                    })
                } : d
            })
        })
    }

    // Toggles the therapist's availability on the day with the given index.
    toggleAvailability (day) {
        this.setState({
            schedule: this.state.schedule.map((d, i) => {
                return i === day ? { ...d, available: !d.available } : d
            })
        })
    }

    // Resets the therapist's availability.
    resetAvailability () {
        this.setState({
            schedule: this.state.schedule.map((day) => {
                return { ...day, available: false }
            })
        })
    }

    // Fetches the therapist's availability.
    fetchAvailability () {
        // Do not disturb.
        if (this.state.doNotDisturb) {
            return
        }

        // Put the do not disturb sign.
        this.setState({ doNotDisturb: true })

        // eslint-disable-next-line no-console
        console.log('Fetch availability.')
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: '/therapist/availability'
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log('Fetched availability.')
                const data = response.data
                const schedule = this.days.map((day, index) => {
                    const timeranges = _.first(data.filter((d) => {
                        return parseInt(d.day, 10) === index
                    })
                        .map((d) => { return d.timeranges }))
                    return {
                        index,
                        name: day,
                        available: !_.isEmpty(timeranges),
                        slots: _.isEmpty(timeranges) ? [{
                            start: moment('10:00', 'HH:mm'),
                            end: moment('18:00', 'HH:mm')
                        }] : timeranges.map((tr) => {
                            return {
                                start: moment(tr.start, 'HH:mm'),
                                end: moment(tr.end, 'HH:mm')
                            }
                        })
                    }
                })
                this.setState({ schedule, doNotDisturb: false })
            })
            .catch((error) => {
                // Failed to fetch availability.
                // eslint-disable-next-line no-console
                console.error('Failed to fetch availability.', error)
                // Hide the error.
                this.setState({ doNotDisturb: false })
            })
    }

    // Updates the therapist's availaibility.
    updateAvailability (force) {
        const data = this.state.schedule.filter((day) => { return day.available })
            .map((day) => {
                return {
                    day: day.index.toString(),
                    timeranges: day.slots.map((slot) => {
                        return { start: slot.start.format('H:mm'), end: slot.end.format('H:mm') }
                    })
                }
            })

        // eslint-disable-next-line no-console
        console.log('Update availability.')
        send({
            method: 'POST',
            tokens: this.props.userTokens,
            data,
            url: `/therapist/availability?force=${force ? 1 : 0}`
        })
            .then((_response) => {
                // eslint-disable-next-line no-console
                console.log('Updated availability.')
                if (force) {
                    this.setState({ doNotDisturb: false, forced: true })
                } else {
                    this.props.onClose()
                }
            })
            .catch((error) => {
                // Failed to update availability.
                // eslint-disable-next-line no-console
                console.error('Failed to update availability.', error)
                // If there are conflicts, the message will be something like.
                // { conflicts: [ ... ] }
                const message = _.isEmpty(error.message) ? {} : JSON.parse(error.message)
                const conflicts = message.conflicts
                // There are conflicts that need to be either resolved or forced.
                if (!_.isEmpty(conflicts)) {
                    this.setState({ conflicts, doNotDisturb: false })
                }
                // Otherwise, something just went wrong.
                else {
                    // Hide the error.
                    this.props.message({ type: 'error', text: tr('FAILED_TO_SAVE_CHANGES') })
                    this.setState({ doNotDisturb: false })
                }
            })
    }

    // Saves the therapist's availaibility.
    saveAvailability () {
        // Do not disturb.
        if (this.state.doNotDisturb) {
            return
        }

        // Put the do not disturb sign, and clear all errors.
        this.setState({ doNotDisturb: true, errors: {} })

        // Validate.
        const errors = this.state.schedule.reduce((derrors, day, index) => {
            const errors = day.slots.reduce((serrors, slot, sindex) => {
                const errors = []
                const start = slot.start
                const end = slot.end
                // The end time cannot be before the start time.
                if (end.isSameOrBefore(start)) {
                    errors.push(tr('END_TIME_CANNOT_BE_BEFORE_START_TIME'))
                }
                // Slots cannot overlap.
                else {
                    if (day.available) {
                        if (day.slots.filter((_s, si) => { return si < sindex })
                            .some((s) => {
                                return start.isSame(s.start) || start.isBetween(s.start, s.end) || end.isBetween(s.start, s.end) ||
                                    end.isSame(s.end)
                            })) {
                            errors.push(tr('SLOTS_CANNOT_OVERLAP'))
                        }
                    }
                }
                return _.isEmpty(errors) ? serrors : { ...serrors, [sindex]: errors }
            }, {})
            return _.isEmpty(errors) ? derrors : { ...derrors, [index]: errors }
        }, {})

        // There are errors. Break.
        if (!_.isEmpty(errors)) {
            this.setState({ doNotDisturb: false, errors })
            return
        }

        // Update the availability.
        this.updateAvailability(false)
    }

    // Forces the changes to the therapist's availability to be saved.
    forceChanges () {
        // Update the availability.
        this.updateAvailability(true)
    }

    // Cancels the changes to the therapist's availability to be saved.
    cancelChanges () {
        this.setState({ conflicts: [] })
    }

    render () {
        return _.isEmpty(this.state.conflicts) ? (
            <Editor
                schedule={this.state.schedule}
                doNotDisturb={this.state.doNotDisturb}
                errors={this.state.errors}
                onClose={this.props.onClose}
                onAddSlot={this.addSlot}
                onRemoveSlot={this.removeSlot}
                onChangeSlot={this.setValue}
                onToggleAvailability={this.toggleAvailability}
                onResetAvailability={this.resetAvailability}
                onSaveAvailability={this.saveAvailability}
            />
        ) : this.state.forced ? (
            <Note
                conflicts={this.state.conflicts}
                timezone={this.props.timezone}
                language={this.props.language}
                onClose={() => { this.props.onClose() }}
            />
        ) : (
            <Warning
                conflicts={this.state.conflicts}
                onSaveChanges={this.forceChanges}
                onCancelChanges={this.cancelChanges}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language,
        timezone: state.settings.timezone,
        userTokens: state.users.userTokens
    }
}

const mapDispatchToProps = (dispatch) => {
    const _messages = bindActionCreators(messages, dispatch)
    return {
        message: _messages.message
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Availability))



// WEBPACK FOOTER //
// ./src/components/availability/index.js